import { useEffect, useRef, useState } from 'react';
import './Facturacion.css';
import Video2 from '../assets/images/Video2.mp4';
import imgFacturacion from '../assets/images/Facturacion.png';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import checkAnim from '../assets/images/check.gif';
import RedNeuronal2 from '../assets/images/Red-Neuronal4.png';
import ImagenSAT from '../assets/images/timbradoSAT.png';


function Facturacion() {
  const scrollToExtraText = () => {
    const section = document.getElementById("Menu-Factu");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  const tituloRef = useRef(null);
  const listaRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.2 });

    if (tituloRef.current) observer.observe(tituloRef.current);
    if (listaRef.current) observer.observe(listaRef.current);

    return () => {
      if (tituloRef.current) observer.unobserve(tituloRef.current);
      if (listaRef.current) observer.unobserve(listaRef.current);
    };
  }, []);

  const [enviado, setEnviado] = useState(false);
  
    const handleSubmit = (e) => {
      e.preventDefault();
      const form = e.target;
  
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      }).then(() => {
        setEnviado(true);
        form.reset();
        // Opcional: volver a mostrar formulario después de 5s
        // setTimeout(() => setEnviado(false), 5000);
      });
    };

  return (
    <>
    {/*Inicio Facturación*/}
      <div className="contenedor-inicio">
        <div className="texto-inicio">
          <h1>
            {/*Titulo Facturación Sección Inicio  */}
            Facturación<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Electrónica
          </h1>
          {/*Descripción Facturacion Sección Inicio */}
          <h2>
            CUMPLE CON LA DISPOSICION DEL SAT,<br />
            AGILIZANDO Y AUTOMATIZANDO TUS<br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;PROCESOS DE TIMBRADO 
          </h2>
{/* Imagen SAT inicio */} 
        <img src={ImagenSAT} alt="Ilustración timbrado SAT" className="imagen-timbrado" />

        </div>
{/* Video de fondo en la sección de inicio Facturacion*/}
        <div className="Video2-inicio">
          <video autoPlay muted loop playsInline>
            <source src={Video2} type="video/mp4" />
            Tu navegador no soporta la etiqueta de video.
          </video>
        </div>
      </div>

{/*Bloque introducción Facturacion*/}
<div style={{
  height: '300px',
  backgroundColor: '#e8e8e8',
  width: '100%',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
  zIndex: 10,
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden'
}}>
  {/* Imagen decorativa encima del fondo blanco */}
  <img
    src={RedNeuronal2}
    alt="red neuronal decorativa"
    style={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
      pointerEvents: 'none'
    }}
  />

  {/* Contenido encima de la imagen */}
  <div style={{ zIndex: 1, maxWidth: '1100px' }}>
    {/*Descripción Sección Facturación */}
    <p className="texto-banner2">
  Mediante Sicai Web genera cualquier tipo de comprobante fiscal sin necesidad de comprar ningún programa, como Facturas, Notas de Crédito, Notas de Cargo, Recibo de Honorarios, Recibos de Arrendamiento y Nómina. También puedes emitir Comprobantes de Retenciones, Complemento de Pago y Complemento de Comercio Exterior, entre otros. Administra tus comprobantes con un sistema de búsqueda por fecha, nombre o R.F.C., y realiza envíos e impresiones ilimitadas. Verifica el estatus, cancela, descarga acuses de recepción o cancelación del SAT y personaliza tus comprobantes cargando tu logotipo y aplicando color. Inicia sesión desde varios equipos y en cualquier parte del mundo, todo sin costo extra. Mantenemos tu información resguardada y segura. Contamos con todos los complementos publicados por el SAT.
  </p>
  </div>
</div>
{/* Bloque detallados Facturacion */}
<div className="caracteristicas-container">
  {/*Titulo detallados Facturacion*/}
  <h2 className="caracteristicas-titulo fade-up" ref={tituloRef}>
    ¿Por qué timbrar con nosotros?
  </h2>

  <div className="caracteristicas-contenido">
    <div className="caracteristicas-imagen">
      {/* Imagen detallados Facturacion */} 
      <img src={imgFacturacion} alt="Facturación CFDI" />
    </div>
{/* Puntos detallados Facturacion */}
    <div className="caracteristicas-texto fade-up" ref={listaRef}>
      <div className="caracteristicas-lista">
  <ul>
    <li>
      Timbrar con un <span className="azulita-destacada">PAC autorizado</span>; evitando tercerizar el servicio de certificación.
    </li>
    <li>
      <span className="azulita-destacada">Timbrar, cancela y valida CFDIs</span> de manera <span className="azulita-destacada">automática</span> desde el uso de nuestro Web Services.
    </li>
    <li>
      Obtener el timbre fiscal para certificar los CFDI’s con un <span className="azulita-destacada">servicio confiable</span> teniendo una <span className="azulita-destacada">disponibilidad</span> de servicio del <span className="azulita-destacada">99.98%</span>.
    </li>
    <li>
      <span className="azulita-destacada">Garantía</span> de servicio ya que contamos con <span className="azulita-destacada">2 centros de datos</span> ubicados en dos ciudades diferentes dentro del territorio nacional.
    </li>
    <li>
      Procesamiento de <span className="azulita-destacada">altos volúmenes</span> de información.
    </li>
    <li>
      Soporte <span className="azulita-destacada">personalizado</span>.
    </li>
    <li>
      <span className="azulita-destacada">Confidencialidad</span> en la información de cada <span className="azulita-destacada">cliente</span>.
    </li>
    <li>
      Resguardo por <span className="azulita-destacada">5 años</span> de los archivos <span className="azulita-destacada">XML</span> en nuestros servidores.
    </li>
    <li>
      <span className="azulita-destacada">Informes</span> de disponibilidad y consumo.
    </li>
  </ul>
</div>

    </div>
  </div>
</div>
{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
    {/* Titulo al enviar*/}
      GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
      
    >
      <input type="hidden" name="_captcha" value="false" />
      {/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

{/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
    {/* Campo Número Telefónico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>

      <button type="submit">Enviar</button>
      {/* Botón de envío del formulario*/}
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>

{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>

{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* IAutomatiza CFDI Colum 2*/}
        <li><a href="/">• IAutomatiza CFDI</a></li>
        {/* Servicio infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Soluciones Tecnológicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      <div className="iconos-redes-nuevos">
        {/*Facebook Colum 2*/}
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Insta Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
        {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
        {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>



    </>

    

  );
}

export default Facturacion;
